var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lead lead__text"},[_c('span',{staticClass:"lead__ligature"},[_vm._v(_vm._s(_vm.ligature))]),_c('p',{domProps:{"innerHTML":_vm._s(_vm.text)}})])}
var staticRenderFns = []

export { render, staticRenderFns }